import HNSColors from "../../../../ui library/HNSColors";
import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import EditButton from "../components/buttons/EditButton";
import ViewDetails from "../components/ViewDetails";
import ViewHeader from "../components/ViewHeader";
import useOnClickButton from "../hooks/useOnClickEventListener";
import { useViewDetailStore } from "../store/viewDetailStore";

export default function LeftPanel() {
  const { loading, initialViewDetail } = useViewDetailStore();
  const { handleOnClickEditButton } = useOnClickButton();

  if (loading) {
    return <LoadingIndicator />;
  }
  
  return (
    <div
      className="flex h-full min-h-0 w-2/6 flex-col shadow-md"
      style={{ borderRadius: "14px", backgroundColor: HNSColors.neutrals[900] }}
    >
      <div className="flex h-full min-h-0 w-full flex-col gap-4 p-4">
        <ViewHeader data={initialViewDetail} />
        <div className="flex min-h-0 flex-1 flex-row gap-1 overflow-y-auto pr-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
          <ViewDetails data={initialViewDetail} />
          <EditButton disabled={false} handleOnClick={handleOnClickEditButton} />
        </div>
      </div>
    </div>
  );
}
